export default __webpack_public_path__ + "static/media/L_Envol_Laurent_Rioux.37515c32.jpg";